import React from "react";
import ResubmitButton from "@components/FlowActionButtons/ResubmitButton";
import { useAuthStore } from "@persisted-state/auth/auth.store";
import { paths } from "@utils/navigation.tsx";
import { useLocation, useNavigate } from "react-router-dom";
import { canUserResubmit } from "./utils";

interface ResubmitMovementProps {
  movementFlowData?: {
    id: string;
    task: { status: string; claimOwnerName: string } | null;
    status: string;
    terminalReport: { report: string } | null;
  };
}

const LANG_BASE = "vessel-call.movement-services";

const ResubmitMovement: React.FC<ResubmitMovementProps> = ({ movementFlowData }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setMovementServiceResubmit } = useAuthStore();

  if (!movementFlowData) {
    return null;
  }

  if (!movementFlowData.task) {
    return null;
  }

  const isActionAvailable = canUserResubmit(
    movementFlowData.task.status,
    movementFlowData.task.claimOwnerName,
    movementFlowData.status,
  );
  const handleUpdateClick = () => {
    const baseMovementServicesPath = location.pathname.replace(/(\/movement-services).*/, "$1");
    navigate(`${baseMovementServicesPath}/${paths.vesselCall.addMovementService}`);
    setMovementServiceResubmit(true);
  };
  return (
    <ResubmitButton
      langBase={LANG_BASE}
      permission="canUpdateMovementService"
      isActionAvailable={isActionAvailable}
      onUpdate={handleUpdateClick}
    />
  );
};
export default ResubmitMovement;
